import { AIConstantsListPage } from '@pages/AIConstants';
import { createMeta } from '@shared/utils';

export function meta() {
  return createMeta('Константы', 'Управление константами');
}

export default AIConstantsListPage;
